module.exports = __webpack_public_path__ + "static/rewards-card-banner-swarm-2d51f5b70745eeb03329a7fa712d78c3.png";